/**
 * «＋ вариант ответа» в редакторе пропусков (решение владельца 13.10.2026, п. 5).
 *
 * Несколько верных ответов у пропуска уже понимают и фронт, и сервер: `[[colour|color]]`.
 * Автору этого не видно — кнопка дописывает «|» в пропуск, где стоит курсор, и ставит
 * курсор сразу после черты: остаётся набрать вариант.
 *
 * Курсор вне `[[…]]` — `null`: в Edvibe-записи со звёздочкой несколько верных отмечают
 * звёздочками, и черта там значила бы другое.
 */
export function addAlternativeAt(template: string, caret: number): { template: string; caret: number } | null {
  const re = /\[\[[^\]]*\]\]/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(template)) !== null) {
    const start = m.index;
    const end = m.index + m[0].length; // сразу после «]]»
    if (caret >= start && caret <= end) {
      const at = end - 2; // перед «]]»
      return { template: `${template.slice(0, at)}|${template.slice(at)}`, caret: at + 1 };
    }
  }
  return null;
}
